import { NgClass } from '@angular/common';
import { ChangeDetectorRef, Component, ElementRef, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';

import { DeviceService } from '../../../core/services/device/device.service';

@Component({
    selector: 'score-digit',
    templateUrl: 'score-digit.component.html',
    styleUrls: ['./score-digit.component.scss'],
    imports: [NgClass],
})
export class ScoreDigitComponent implements OnInit, OnChanges {
    @Input() number: number | string;
    @Input() animationDelay?: number;
    @Input() isFootball?: boolean;

    showAnimatedDigit: boolean = false;
    isAndroidWrapper: boolean;
    digits: Array<string>;

    private scoreDigitEl: HTMLElement;

    constructor(
        private device: DeviceService,
        private elementRef: ElementRef,
        private changeDetectorRef: ChangeDetectorRef,
    ) {
        this.scoreDigitEl = this.elementRef.nativeElement;
    }

    ngOnInit() {
        this.isAndroidWrapper = this.device.isAndroid && this.device.isWrapper;
        this.digits = `${this.number}`.split('');
    }

    ngOnChanges(changes: SimpleChanges) {
        const numberValue = changes.number;
        if (!this.isAndroidWrapper && numberValue && !numberValue.firstChange && numberValue.currentValue !== numberValue.previousValue) {
            this.showAnimatedDigit = true;

            setTimeout(() => {
                this.digits = `${changes.number.currentValue}`.split('');
            }, this.animationDelay);
            if (this.isFootball) {
                this.scoreDigitEl.addEventListener(
                    'transitionstart',
                    () => {
                        this.scoreDigitEl.parentElement!.classList.add('color-changes');
                    },
                    { once: true },
                );
            }

            this.scoreDigitEl.addEventListener(
                'transitionend',
                () => {
                    if (this.isFootball) {
                        setTimeout(() => {
                            this.scoreDigitEl.parentElement!.classList.remove('color-changes');
                        }, 1000);
                    }
                    this.showAnimatedDigit = false;
                    this.changeDetectorRef.detectChanges();
                },
                { once: true },
            );
        }
    }
}
